import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addHolidayList = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Holiday List',
    body
  );
  return data;
});
export const updateHolidayList = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Holiday List/${id}`,
    body
  );
  return data;
});

export const getHolidayList = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Holiday List?fields=["holiday_list_name","name","from_date","to_date","total_holidays"]'
  );
  return data;
});
export const deleteHolidayList = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Holiday List/${record}`
  );
  return data;
});
export const getHolidayListDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Holiday List/${id}`
  );
  return data;
});
